export default __webpack_public_path__ + "static/media/favicon.b1d4c99c.ico";